import { useState, useContext } from "react";
import HttpService from "./http.service";
import MDSnackbar from "components/MDSnackbar";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context";

export const useAxiosInterceptor = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      content={errorMessage}
      open={errorSB}
      onClose={() => setErrorSB(false)}
      close={() => setErrorSB(false)}
    />
  );

  const setupAxiosInterceptors = () => {
    const onRequestSuccess = async (config) => {
      const token = localStorage.getItem("token");
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    };

    const onRequestFail = (error) => Promise.reject(error);

    HttpService.addRequestInterceptor(onRequestSuccess, onRequestFail);

    const onResponseSuccess = (response) => response;

    const onResponseFail = (error) => {
      setErrorMessage(error.response?.data?.message || "An error occurred");
      setErrorSB(true);
      const status = error.response?.status;
      if (status === 403 || status === 401) {
        authContext.logout();
        navigate("/auth/login");
      }

      return Promise.reject(error);
    };

    HttpService.addResponseInterceptor(onResponseSuccess, onResponseFail);
  };

  return {
    renderErrorSB, setupAxiosInterceptors
  };
};
